import { NavLink } from 'react-router-dom';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const FooterNavigationLink: FunctionComponent<Props> = ({
    className = '',
    label,
    link,
    onClick,
    testId = TEST_ID
}) => (
    <NavLink
        className={({ isActive }) =>
            `${className} ${styles.footerNavigationLink} ${
                isActive ? styles.linkActive : styles.linkInactive
            }`
        }
        data-testid={testId}
        end
        onClick={onClick}
        to={link}
    >
        {label}
    </NavLink>
);

export default FooterNavigationLink;
